/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from 'react-bootstrap/Button';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import InputAdornment from '@mui/material/InputAdornment';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import {
  ERROR_DATE_FORMAT,
  ENTER_NUMERIC_ONLY_ERROR,
  DATE_FUTURE_ERROR,
  BATCH_NUMBER_ALREADY_EXISTS,
  BATCH_NUMBER_NOT_NULL,
  BATCH_DATE_NOT_NULL,
  TOT_CHECKS_NOT_NULL,
  TOT_AMT_CHECKS_NOT_NULL,
  CHECK_PAYEE_NOT_NULL,
  DATE_BACKWARD_ERROR,
  SUCCESS_MESSAGE,
  SAVE_ERROR_NDC,
} from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  checkBatch,
  checkDateFormat,
  checkFutureDate,
  checkIfNum,
  checkBackwardDate,
} from './commonFunctions';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  setLogBatchTotalSelectListDetail,
  getLogBatchHistory,
  getLogCheckDetails,
  handleSaveAPI,
  dispatchLogCheckDetails,
  dispatchLogBatchTotalSelectedListDetail,
  handleErrorMessages,
  dispatchLogBatchTotalList,
  getCheckPayeeList,
  setDetailScreenObj,
} from '../store/actions';
import {
  closeTab,
  replaceCommaIntoWhiteSpace,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';
import {
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import {
  dateFormatForDatePicker,
  MinDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';

function LogBatchTotalForm(props) {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getFetchLogBatchDetail = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.logBatchDetail
  );  
  const fetchDetailScreenObj = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.detailScreenObj
  );
  const logCheckDetails = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.logCheckDetails
  );

  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.LogBatchTotalReducer.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const history = useHistory();
  const updateLogBatchTotalDetail = (value) =>
    dispatch(setLogBatchTotalSelectListDetail(value));
  const fethLogBatchHistory = (value) => dispatch(getLogBatchHistory(value));
  const fetchLogCheckDetails = (value) => dispatch(getLogCheckDetails(value));
  const [saveView, setSaveView] = useState(false);
  const [cancelView, setCancelView] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);
  const [disabled, setDisabled] = useState(false);  
  const [batchNumVal, setBatchNumVal] = useState('');
  const [dateVal, setDateVal] = useState('');
  const [amountVal, setAmountVal] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const [checkPVal, setCheckPVal] = useState('');
  const [keyValue, setKeyValue] = useState({});
  const [tabError, setTabError] = useState(
    errorMessagesFromRedux?.detailLogErrors
      ? errorMessagesFromRedux?.detailLogErrors
      : []
  );
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [cancelDisabled, setCancelDisabled] = useState(true);
  const [historyView, setHistoryView] = useState(false);
  const [enableHistoryView, setEnableHistoryView] = useState(true);
  const [batchForPayeeList, setBatchForPayeeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limitLength, setLimitLength] = useState(11);
  const [formValue, setFormValue] = useState({
    batchNum: '',
    batchDt: '',
    checkPayeeCd: userDefaults?.checkPayeeCd
      ? userDefaults?.checkPayeeCd
      : '-1',
    checkTotCnt: '',
    checkTotAmt: '',
    totCheckCnt: '',
    totCheckAmt: '',
  });
  const [checkVal, setCheckVal] = useState({
    totAmt: '',
    totChk: '',
  });
  const [checkPayeeList, setCheckPayeeList] = useState([]);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    if (errorMessagesFromRedux?.successMessage) {
      if (successMessages.length > 0) {
        if (!clickOncloseTabBtn) {
          closeTab('/logBatchDetail', history);
        }
      }
    }
  }, [errorMessagesFromRedux?.successMessage, saveDisabled]);
  React.useEffect(() => {
    if (errorMessagesFromRedux?.batchNum) {
      if (
        errorMessagesFromRedux?.batchNum !=
        getFetchLogBatchDetail?.orgData?.batchNum
      ) {
        const errorObjIf = errorMessagesFromRedux || {};
        errorObjIf.detailLogErrors = [];
        errorObjIf.batchNum = getFetchLogBatchDetail?.orgData?.batchNum
          ? getFetchLogBatchDetail?.orgData?.batchNum
          : '';

        errorObjIf.successMessage = '';
        setTabError([]);

        dispatch(handleErrorMessages(errorObjIf));
      }
    } else if (getFetchLogBatchDetail?.actionType != 'Add') {
      const errorObj = errorMessagesFromRedux || {};
      errorObj.detailLogErrors = [];
      errorObj.batchNum = getFetchLogBatchDetail?.orgData?.batchNum
        ? getFetchLogBatchDetail?.orgData?.batchNum
        : '';
      errorObj.successMessage = '';
      setTabError([]);

      dispatch(handleErrorMessages(errorObj));
    }
    if (getFetchLogBatchDetail?.orgData?.cfFrozen === '1') {
      setDisabled(true);
      setSaveDisabled(true);
      setCancelDisabled(true);
    }
    setCheckVal({
      totAmt: '',
      totChk: '',
    });
    dispatch(
      dispatchLogCheckDetails({
        totAmt: '',
        totChk: '',
      })
    );

    if (getFetchLogBatchDetail?.actionType == 'Add') {
      setFormValue({
        batchNum: '',
        batchDt: '',
        checkPayeeCd: userDefaults?.checkPayeeCd
          ? userDefaults?.checkPayeeCd
          : '-1',
        checkTotCnt: '',
        checkTotAmt: '',
        totCheckCnt: '',
        totCheckAmt: '',
      });
    }
  }, []);

  React.useEffect(() => {
    let list = [];
    setLoading(false);
    if (checkPayeeList && !_.isEmpty(checkPayeeList)) {
      if (
        checkPayeeList.CHECK_PAYEE_CD &&
        !_.isEmpty(checkPayeeList.CHECK_PAYEE_CD)
      ) {
        list = _.map(checkPayeeList.CHECK_PAYEE_CD, (val, ind) => ({
          id: val?.codeValueID?.codeValue,
          name: `${val?.codeValueID?.codeValue} - ${val.shortDescription}`,
        }));
      }
    }
    setBatchForPayeeList(list);
  }, [checkPayeeList]);
  React.useEffect(() => {
    getCheckPayeeList({ codeDomainList: ['CHECK_PAYEE_CD'] }).then((resp) => {
      setCheckPayeeList(resp);
    });
  }, []);
  React.useEffect(() => {
    if (fetchDetailScreenObj && Object.keys(fetchDetailScreenObj)?.length > 0) {
      setSaveDisabled(false);
      setCancelDisabled(false);
    } else {
      setSaveDisabled(true);
      setCancelDisabled(true);
    }
  }, [fetchDetailScreenObj]);
  React.useEffect(() => {
    if (getFetchLogBatchDetail.actionType != 'Add') {
      if (
        getFetchLogBatchDetail?.orgData?.batchNum &&
        getFetchLogBatchDetail?.orgData?.checkPayeeCd
      ) {
        fetchLogCheckDetails({
          batchNumber: getFetchLogBatchDetail?.orgData?.batchNum,

          checkCode: getFetchLogBatchDetail?.orgData?.checkPayeeCd,
        });
      } else {
        dispatch(dispatchLogCheckDetails({ totAmt: '0.00', totChk: '0' }));
      }
    } else {
      dispatch(dispatchLogCheckDetails([]));
    }

    if (getFetchLogBatchDetail?.orgData?.cfFrozen == '1') {
      setDisabled(true);
      setSaveDisabled(true);
      setCancelDisabled(true);
    }
  }, [getFetchLogBatchDetail?.orgData]);

  React.useEffect(() => {
    if (logCheckDetails) {
      if (
        logCheckDetails.message === 'SUCESS' &&
        logCheckDetails.status === '001'
      ) {
        const obj = {
          totAmt: logCheckDetails?.data?.sumAmt
            ? logCheckDetails?.data?.sumAmt
            : '0.00',
          totChk: logCheckDetails?.data?.totalCountBatchNum
            ? logCheckDetails?.data?.totalCountBatchNum
            : '0',
        };
        setCheckVal(obj);
      } else {
        setCheckVal({ totAmt: '0.00', totChk: '0' });
      }
    }
  }, [logCheckDetails]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/logBatchDetail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/logBatchDetail' && item.isFormSave) {
          item.isFormSave = false;
          callSaveAPI(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  React.useEffect(() => {
    if (!_.isEmpty(getFetchLogBatchDetail)) {
      if (!_.isEmpty(getFetchLogBatchDetail.updatedData)) {
        setFormValue(getFetchLogBatchDetail.updatedData);
      }
      if (
        !_.isEmpty(getFetchLogBatchDetail.actionType) &&
        getFetchLogBatchDetail.actionType === 'Update'
      ) {
        setEnableHistoryView(false);
      }
    }
    setLoading(false);
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/logBatchDetail' && !saveDisabled) {
          item.isFormDirty = true;
          if (tabError && tabError.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (
          item.navTo === '/logBatchDetail' &&
          successMessages.length > 0
        ) {
          item.isFormError = false;
          item.isFormDirty = false;
        } else if (item.navTo === '/logBatchDetail' && cancelDisabled) {
          if (tabError && tabError.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
          item.isFormDirty = false;
        }
        return item;
      });

    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [
    getFetchLogBatchDetail.updatedData,
    JSON.stringify(tabError),
    JSON.stringify(errorMessagesFromRedux),
    saveDisabled,
    cancelDisabled,
  ]);

  const checkLength = (value) => {
    if (value && value?.includes('.')) {
      setLimitLength(value?.split('.')[0].length + 3);
    } else if (!(value && value?.includes('.'))) {
      setLimitLength(11);
    }
  };

  const onChangeFormAction = (flType, value) => {
    if (flType === 'totCheckAmt') {
      checkLength(value);
    }
  
    // Reset success + error messages
    const succObj = {
      ...errorMessagesFromRedux,
      detailLogErrors: errorMessagesFromRedux?.detailLogErrors || [],
      batchNum: errorMessagesFromRedux?.batchNum || '',
      successMessage: ''
    };
  
    setTabError(succObj.detailLogErrors);
    dispatch(handleErrorMessages(succObj));
  
    // IMPORTANT: update state AND redux using the SAME updated object
    setFormValue(prev => {
      const updated = { ...prev, [flType]: value };
  
      dispatch(dispatchLogBatchTotalSelectedListDetail({
        orgData: getFetchLogBatchDetail?.orgData,
        updatedData: updated,
        actionType: getFetchLogBatchDetail?.actionType
      }));
      return updated;
    });
    if (flType !== 'totCheckAmt') {
      setSaveDisabled(false);
      setCancelDisabled(false);
    }
  };
  const onBlurFormAction = (flType, value) => {
  
    let errorMsg = errorMessagesFromRedux?.detailLogErrors
      ? errorMessagesFromRedux?.detailLogErrors
      : [];

    if (flType == 'batchNum') {
      let btchBool = false;
      let btchError = '';
      if (value) {
        btchBool = false;
        setBatchNumVal('');
        btchError = '';
      } else {
        btchBool = true;
        setBatchNumVal('td-active-cell tBill-validate');
        btchError = BATCH_NUMBER_NOT_NULL;
      }
      if (!btchBool) {
        setBatchNumVal('');

        const indexOf = !_.isEmpty(errorMsg)
          ? _.findIndex(errorMsg, {
              field: 'batchNum',
              errorType: 'BATCH_SAVE_ERROR',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorMsg.splice(indexOf, 1);
        }

        updateLogBatchTotalDetail({
          ...getFetchLogBatchDetail,
          orgData: getFetchLogBatchDetail.orgData,
          updatedData: formValue,
        });
        dispatch(setDetailScreenObj(formValue));
      } else {
        errorMsg = errorMsg.filter(
          (item) => item.errorType != 'BATCH_SAVE_ERROR'
        );

        errorMsg.push({
          field: flType,
          error: true,
          errorType: 'BATCH_SAVE_ERROR',
          message: btchError,
        });
      }
    }
    if (flType == 'batchDt') {
      let bool = false;
      let dateError = '';
      if (value) {
        if (checkDateFormat(value) == false) {
          dateError = ERROR_DATE_FORMAT;
          bool = true;
          setDateVal('td-active-cell tBill-validate');
        } else if (!checkFutureDate(value)) {
          dateError = DATE_FUTURE_ERROR;
          bool = true;
          setDateVal('td-active-cell tBill-validate');
        } else if (!checkBackwardDate(value)) {
          bool = true;

          dateError = DATE_BACKWARD_ERROR;
          setDateVal('td-active-cell tBill-validate');
        } else {
          bool = false;

          dateError = '';
          setDateVal('');
        }
      } else {
        dateError = BATCH_DATE_NOT_NULL;
        bool = true;
        setDateVal('td-active-cell tBill-validate');
      }

      if (!bool) {
        setDateVal('');
        const indexOf = !_.isEmpty(errorMsg)
          ? _.findIndex(errorMsg, {
              field: flType,
              errorType: 'DATE_ERROR',
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorMsg.splice(indexOf, 1);
        }

        updateLogBatchTotalDetail({
          ...getFetchLogBatchDetail,
          orgData: getFetchLogBatchDetail.orgData,
          updatedData: formValue,
        });
        dispatch(setDetailScreenObj(formValue));
      } else {
        errorMsg = errorMsg.filter((item) => item.errorType != 'DATE_ERROR');

        errorMsg.push({
          field: flType,
          error: true,
          errorType: 'DATE_ERROR',
          message: dateError,
        });
      }
    }
    if (flType == 'checkPayeeCd') {
      let dropBool = false;
      let dropError = '';
      if (value != '-1' && value != '') {
        dropBool = false;
        setCheckPVal('');
        dropError = '';
      } else {
        dropBool = true;
        setCheckPVal('td-active-cell tBill-validate');
        dropError = CHECK_PAYEE_NOT_NULL;
      }
      if (!dropBool) {
        setCheckPVal('');

        const indexOf = !_.isEmpty(errorMsg)
          ? _.findIndex(errorMsg, {
              field: 'checkPayeeCd',
              errorType: 'CHK_PY_SAVE_ERROR',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorMsg.splice(indexOf, 1);
        }

        updateLogBatchTotalDetail({
          ...getFetchLogBatchDetail,
          orgData: getFetchLogBatchDetail.orgData,
          updatedData: formValue,
        });
        dispatch(setDetailScreenObj(formValue));
      } else {
        errorMsg = errorMsg.filter(
          (item) => item.errorType != 'CHK_PY_SAVE_ERROR'
        );

        errorMsg.push({
          field: flType,
          error: true,
          errorType: 'CHK_PY_SAVE_ERROR',
          message: dropError,
        });
      }
    }
    if (flType == 'totCheckCnt') {
      let checkBool = false;
      let totCheckError = '';
      if (value) {
        if (!checkIfNum(value)) {
          checkBool = true;

          totCheckError = ENTER_NUMERIC_ONLY_ERROR('Total Number of Checks');
          setNumberVal('td-active-cell tBill-validate');
        } else {
          checkBool = false;

          totCheckError = '';
          setNumberVal('');
        }
      } else {
        checkBool = true;

        totCheckError = TOT_CHECKS_NOT_NULL;
        setNumberVal('td-active-cell tBill-validate');
      }
      if (!checkBool) {
        setNumberVal('');

        const indexOf = !_.isEmpty(errorMsg)
          ? _.findIndex(errorMsg, {
              field: flType,
              errorType: 'TOTCHK_ERROR',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorMsg.splice(indexOf, 1);
        }

        updateLogBatchTotalDetail({
          ...getFetchLogBatchDetail,
          orgData: getFetchLogBatchDetail.orgData,
          updatedData: formValue,
        });
        dispatch(setDetailScreenObj(formValue));
      } else {
        errorMsg = errorMsg.filter((item) => item.errorType != 'TOTCHK_ERROR');

        errorMsg.push({
          field: flType,
          error: true,
          errorType: 'TOTCHK_ERROR',
          message: totCheckError,
        });
      }
    }
    if (flType == 'totCheckAmt') {
      let checkBoolAmt = false;
      let totCheckAmtError = '';
      if (value) {
     
      } else {
        checkBoolAmt = true;
        totCheckAmtError = TOT_AMT_CHECKS_NOT_NULL;
        setAmountVal('td-active-cell tBill-validate');
      }
      if (!checkBoolAmt) {
        const indexOf = !_.isEmpty(errorMsg)
          ? _.findIndex(errorMsg, {
              field: flType,
              errorType: 'TOTCHKAMT_ERROR',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          errorMsg.splice(indexOf, 1);
        }
        setAmountVal('');
        updateLogBatchTotalDetail({
          ...getFetchLogBatchDetail,
          orgData: getFetchLogBatchDetail.orgData,
          updatedData: { ...formValue, totCheckAmt: value },
        });
        dispatch(setDetailScreenObj({ ...formValue, totCheckAmt: value }));
      } else {
        errorMsg = errorMsg.filter(
          (item) => item.errorType != 'TOTCHKAMT_ERROR'
        );
        errorMsg.push({
          field: flType,
          error: true,
          errorType: 'TOTCHKAMT_ERROR',
          message: totCheckAmtError,
        });
      }
    }
    const unique = errorMsg.filter(
      (v, i, a) =>
        a.findIndex(
          t => t.field === v.field && t.errorType === v.errorType
        ) === i
    );
    
    setErrorMessages(unique);
    const obj = errorMessagesFromRedux || {};
    obj.detailLogErrors = unique;
    obj.batchNum = errorMessagesFromRedux.batchNum;
    obj.successMessage = errorMessagesFromRedux.successMessage;
    setTabError(unique);
    setSaveDisabled(false);
    setCancelDisabled(false);
    dispatch(handleErrorMessages(obj));
  };

  const getShowViewHistoryPlan = () => {
    if (
      !_.isEmpty(formValue) &&
      !_.isNull(formValue?.batchNum?.toString()?.trim())
    ) {
      setHistoryView(true);
      setLoading(true);
      setKeyValue({ BATCH_NUM: formValue.batchNum?.toString()?.trim() });
    }

    setLoading(false);
  };
  const handleSave = () => {
    setSaveView(true);
  };

  const checkBatchValidation = async () => {
    if (
      formValue?.batchNum?.toString()?.trim() ===
      getFetchLogBatchDetail?.orgData?.batchNum?.toString()?.trim()
    ) {
      return 'Check not needed';
    }
    const count = await checkBatch(formValue?.batchNum?.toString()?.trim());
    if (count == '0') {
      return 'Fine';
    }
    if (count == 'API failed') {
      return 'API failed';
    }
    return 'Exists';
  };
  const callSaveAPI = async (value) => {
    const data={...formValue};
    setErrorMessages([]);
    setTabError([]);
    setClickOncloseTabBtn(value);
    let errorMsgOnSave = [];
    if (formValue?.batchNum?.toString()?.trim()) {
      var errorPresent = false;
      const resBatch = await checkBatchValidation();
      var btchSvError = '';
      if (resBatch == 'Fine' || resBatch == 'Check not needed') {
        setLoading(false);
        setBatchNumVal('');
        btchSvError = '';
      } else if (resBatch == 'Exists') {
        btchSvError = BATCH_NUMBER_ALREADY_EXISTS;
        setLoading(false);
        setBatchNumVal('td-active-cell tBill-validate');
        errorPresent = true;
      } else if (resBatch == 'API failed') {
        btchSvError = SAVE_ERROR_NDC;
        setLoading(false);
        setBatchNumVal('td-active-cell tBill-validate');
        errorPresent = true;
      } else {
        setLoading(false);
        setBatchNumVal('td-active-cell tBill-validate');
        errorPresent = true;
        btchSvError = SAVE_ERROR_NDC;
      }
    } else {
      errorPresent = true;

      setBatchNumVal('td-active-cell tBill-validate');

      btchSvError = BATCH_NUMBER_NOT_NULL;
    }

    if (!errorPresent) {
      setBatchNumVal('');
      const indexOf = !_.isEmpty(errorMsgOnSave)
        ? _.findIndex(errorMsgOnSave, {
            field: 'batchNum',
            errorType: 'BATCH_SAVE_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMsgOnSave.splice(indexOf, 1);
      }
    } else {
      errorMsgOnSave.push({
        field: 'batchNum',
        error: true,
        errorType: 'BATCH_SAVE_ERROR',
        message: btchSvError,
      });
    }
    if (data.batchDt) {
      var batchdtSaveErr = '';
      var batchDtErr = false;
      if (checkDateFormat(data.batchDt) == false) {
        batchdtSaveErr = ERROR_DATE_FORMAT;
        batchDtErr = true;

        setDateVal('td-active-cell tBill-validate');
      } else if (!checkFutureDate(data.batchDt)) {
        batchdtSaveErr = DATE_FUTURE_ERROR;
        batchDtErr = true;

        setDateVal('td-active-cell tBill-validate');
      } else if (!checkBackwardDate(data.batchDt)) {
        batchdtSaveErr = DATE_BACKWARD_ERROR;
        batchDtErr = true;

        setDateVal('td-active-cell tBill-validate');
      } else {
        batchdtSaveErr = '';
        setDateVal('');
      }
    } else {
      batchDtErr = true;

      setDateVal('td-active-cell tBill-validate');

      batchdtSaveErr = BATCH_DATE_NOT_NULL;
    }
    if (!batchDtErr) {
      setDateVal('');
      const indexOf = !_.isEmpty(errorMsgOnSave)
        ? _.findIndex(errorMsgOnSave, {
            field: 'batchDt',
            errorType: 'DATE_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMsgOnSave.splice(indexOf, 1);
      }
    } else {
      errorMsgOnSave = errorMsgOnSave.filter(
        (item) => item.errorType != 'DATE_ERROR'
      );
      errorMsgOnSave.push({
        field: 'batchDt',
        error: true,
        errorType: 'DATE_ERROR',
        message: batchdtSaveErr,
      });
    }

    if (data.totCheckCnt) {
      var totErrPr = false;
      var totErrSave = '';
      if (!checkIfNum(data.totCheckCnt)) {
        totErrPr = true;

        totErrSave = ENTER_NUMERIC_ONLY_ERROR('Total Number of Checks');
        setNumberVal('td-active-cell tBill-validate');
      } else {
        totErrSave = '';
        setNumberVal('');
      }
    } else {
      totErrPr = true;

      setNumberVal('td-active-cell tBill-validate');

      totErrSave = TOT_CHECKS_NOT_NULL;
    }
    if (!totErrPr) {
      setNumberVal('');
      const indexOf = !_.isEmpty(errorMsgOnSave)
        ? _.findIndex(errorMsgOnSave, {
            field: 'totCheckCnt',
            errorType: 'TOTCHK_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMsgOnSave.splice(indexOf, 1);
      }
    } else {
      errorMsgOnSave.push({
        field: 'totCheckCnt',
        error: true,
        errorType: 'TOTCHK_ERROR',
        message: totErrSave,
      });
    }
    if (data.totCheckAmt) {
      var totChkAmPr = false;
      var totChkAmtErr = '';
    } else {
      totChkAmPr = true;

      setAmountVal('td-active-cell tBill-validate');
      totChkAmtErr = TOT_AMT_CHECKS_NOT_NULL;
    }

    if (!totChkAmPr) {
      setAmountVal('');
      const indexOf = !_.isEmpty(errorMsgOnSave)
        ? _.findIndex(errorMsgOnSave, {
            field: 'totCheckAmt',
            errorType: 'TOTCHKAMT_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMsgOnSave.splice(indexOf, 1);
      }
    } else {
      errorMsgOnSave.push({
        field: 'totCheckAmt',
        error: true,
        errorType: 'TOTCHKAMT_ERROR',
        message: totChkAmtErr,
      });
    }
    if (data.checkPayeeCd || data.checkPayeeCd == '') {
      var chkPErr = '';
      var chkPPres = false;
      if (data.checkPayeeCd != '-1' && data.checkPayeeCd != '') {
        setCheckPVal('');

        chkPErr = '';
      } else {
        chkPPres = true;

        setCheckPVal('td-active-cell tBill-validate');

        chkPErr = CHECK_PAYEE_NOT_NULL;
      }
    }

    if (!chkPPres) {
      setCheckPVal('');
      const indexOf = !_.isEmpty(errorMsgOnSave)
        ? _.findIndex(errorMsgOnSave, {
            field: 'checkPayeeCd',
            errorType: 'CHK_PY_SAVE_ERROR',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        errorMsgOnSave.splice(indexOf, 1);
      }
    } else {
      errorMsgOnSave.push({
        field: 'checkPayeeCd',
        error: true,
        errorType: 'CHK_PY_SAVE_ERROR',
        message: chkPErr,
      });
    }

    setLoading(true);
    if (errorMsgOnSave.length > 0) {
      const unique = [...new Set(errorMsgOnSave)];
      setErrorMessages(unique);
      var obj = errorMessagesFromRedux || {};
      obj.detailLogErrors = unique;
      obj.batchNum = errorMessagesFromRedux.batchNum;
      setTabError(unique);
      obj.successMessage = '';

      dispatch(handleErrorMessages(obj));
      setSaveView(false);
      setLoading(false);
    } else {
      const msgSaveError = [];

      const payload = {
        batchNum: data?.batchNum?.toString()?.trim(),
        previouslyBatchNum: getFetchLogBatchDetail?.orgData?.batchNum
          ? getFetchLogBatchDetail?.orgData?.batchNum
          : '',
        batchDt: data.batchDt,
        checkPayeeCd: data.checkPayeeCd,
        totCheckCnt: data.totCheckCnt ? data.totCheckCnt : '0',
        totCheckAmt: data.totCheckAmt
          ? data.totCheckAmt?.toString()?.replace('$', '')
          : '0.00',

        lastUpdateUserId: logInUser,
        corrLinkId: data.corrLinkId ? data.corrLinkId : '',
        checkTotAmt: data.checkTotAmt
          ? data.checkTotAmt.toString().replace('$', '')
          : '0.00',
        checkTotCnt: data.checkTotCnt ? data.checkTotCnt : '0',
        cfFrozen: data?.cfFrozen ? data.cfFrozen : 1,
      };
      const check = await handleSaveAPI(payload);
      setSaveView(false);
      if (check?.data?.message == 'SUCESS' && check?.data?.status == '001') {
        dispatch(dispatchLogBatchTotalList({}));
        setLoading(false);
        setSuccessMessages([SUCCESS_MESSAGE]);
        setCancelDisabled(true);
        setSaveDisabled(true);
        const errorObj = errorMessagesFromRedux || {};
        errorObj.detailLogErrors = [];
        errorObj.batchNum = '';
        errorObj.successMessage = SUCCESS_MESSAGE;
        setTabError([]);

        dispatch(handleErrorMessages(errorObj));
        const obj = {};
        obj.orgData = getFetchLogBatchDetail?.updatedData;
        obj.updatedData = getFetchLogBatchDetail?.updatedData;
        obj.actionType = 'Update';

        dispatch(dispatchLogBatchTotalSelectedListDetail(obj));
        const indexOf = !_.isEmpty(msgSaveError)
          ? _.findIndex(msgSaveError, {
              field: 'SaveError',
              errorType: 'SAVE_ERROR',
            })
          : null;
        if (!_.isNull(indexOf) && indexOf >= 0) {
          msgSaveError.splice(indexOf, 1);
        }
      } else {
        msgSaveError.push({
          field: 'SaveError',
          error: true,
          errorType: 'SAVE_ERROR',
          message: SAVE_ERROR_NDC,
        });
        setLoading(false);
      }

      const unique = [...new Set(msgSaveError)];
      setErrorMessages(unique);
      var obj = errorMessagesFromRedux || {};
      obj.detailLogErrors = unique;
      obj.successMessage = errorMessagesFromRedux.successMessage;
      obj.batchNum = formValue.batchNum;

      setTabError(unique);

      dispatch(handleErrorMessages(obj));
    }
  };

  const handleCancel = () => {
    setCancelView(true);
  };

  const callCancel = () => {
    const errorObj = errorMessagesFromRedux || {};
    errorObj.detailLogErrors = [];
    errorObj.batchNum = '';
    errorObj.successMessage = '';
    setTabError([]);

    dispatch(handleErrorMessages(errorObj));
    const obj = {};
    obj.updatedData = getFetchLogBatchDetail?.orgData
      ? getFetchLogBatchDetail?.orgData
      : {};
    obj.orgData = getFetchLogBatchDetail?.orgData
      ? getFetchLogBatchDetail?.orgData
      : {};
    obj.actionType = getFetchLogBatchDetail?.actionType;
    if (getFetchLogBatchDetail?.actionType == 'Add') {
      setFormValue({
        batchNum: '',
        batchDt: '',
        checkPayeeCd: userDefaults?.checkPayeeCd
          ? userDefaults?.checkPayeeCd
          : '-1',
        checkTotCnt: '',
        checkTotAmt: '',
        totCheckCnt: '',
        totCheckAmt: '',
      });
    }

    dispatch(dispatchLogBatchTotalSelectedListDetail(obj));

    setCancelView(false);
    setCancelDisabled(true);
    setSaveDisabled(true);
  };

  return (
    <div
      className='logBatchTotal tBillPanel padding-0 '
      data-testid='logBatch-form-component'
    >
      <SaveCancelPopup
        open={saveView}
        title='Save'
        onConfim={(e) => callSaveAPI(true)}
        onCancel={(e) => setSaveView(false)}
        moduleName=''
        data-testid='log-batch-save-popup'
      />
      <SaveCancelPopup
        open={cancelView}
        title='Cancel'
        onConfim={callCancel}
        onCancel={(e) => setCancelView(false)}
        moduleName=''
        data-testid='log-batch-cancel-popup'
      />
      <Spinner load={loading} />
      <div className='tabs-container'>
        <CustomSeparator parent1='Tasks' parent2='Batch Total Detail' />

        {errorMessagesFromRedux?.detailLogErrors?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              errorMessagesFromRedux?.detailLogErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux.detailLogErrors,
                    (l) => l.message
                  )
                : []
            }
          />
        ) : null}

        <DisplaySuccessMessages
          successMessages={
            errorMessagesFromRedux?.successMessage
              ? [errorMessagesFromRedux?.successMessage]
              : []
          }
        />
        <div className='no-margin'>
          <fieldset className='custom-fieldset logBatchField mb-2'>
            <div className='row mb-2'>
              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='batches-number-detail'
                      id='batch-number-detail'
                      required
                      label='Batch Number'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={disabled || !isEnablebyRole}
                      className={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'batchNum' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'batchNum' ? l.message : null
                            )
                          : null
                      }
                      inputProps={{ maxlength: 50 }}
                      value={formValue.batchNum || ''}
                      onChange={(e) =>
                        onChangeFormAction('batchNum', e.target.value)
                      }
                      onBlur={(e) =>
                        onBlurFormAction('batchNum', e.target.value)
                      }
                    />
                    <div className='frr-errorMessage'>
                      {' '}
                      {errorMessagesFromRedux?.detailLogErrors?.length > 0
                        ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                            l.field == 'batchNum' ? l.message : null
                          )
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    {/* <TextField
                      data-testid="batches-date-detail"
                      id="batch-date-detail"
                      label="Batch Date"
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'batchDt' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'batchDt' ? l.message : null
                            )
                          : null
                      }
                      disabled={disabled || !isEnablebyRole}
                      inputProps={{ maxlength: 10 }}
                      value={formValue.batchDt}
                      onChange={(e) =>
                        onChangeFormAction('batchDt', e.target.value)
                      }
                      onBlur={(e) => {
                        let { value } = e.target;
                        value = autoFormateDate(value);

                        onChangeFormAction('batchDt', value);
                        onBlurFormAction('batchDt', value);
                      }}
                    /> */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disabled={disabled || !isEnablebyRole}
                        required
                        id='Batch_Date'
                        inputProps={{ id: 'Batch_Date' }}
                        data-testid='Batch_Date'
                        label='Batch Date'
                        className={
                          errorMessagesFromRedux?.detailLogErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.detailLogErrors,
                                (l) =>
                                  l.field == 'batchDt'
                                    ? 'tBill-validate mandate-fields'
                                    : null
                              )
                            : null
                        }
                        format={dateFormatForDatePicker}
                        inputFormat={dateFormatForDatePicker}
                        mask='__/__/____'
                        minDate={MinDate}
                        maxDate={new Date()}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: false,
                          autoFill: false,
                          id: `batch_date`,
                        }}
                        placeholder='mm/dd/yyyy'
                        value={formValue.batchDt}
                        onChange={(date) => {
                          if (!date) {
                            // user cleared the date manually
                            setFormValue(prev => ({ ...prev, batchDt: '' }));
                            onChangeFormAction('batchDt', '');
                            return;
                          }
                        
                          if (moment(date).isValid()) {
                            const formatted = moment(date).format('MM/DD/YYYY');
                            setFormValue(prev => ({ ...prev, batchDt: formatted }));
                            onChangeFormAction('batchDt', formatted);
                            onBlurFormAction('batchDt', formatted);
                          }
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value.trim();  
                          setFormValue(prev => ({ ...prev, batchDt: raw }));
                          onBlurFormAction('batchDt', raw);                  
                        }}
                        
                        
                        
                        KeyboardButtonProps={{
                          'aria-label': 'batch date',
                        }}
                        onKeyDown={async (e) => {
                          if (e.keyCode == 67) {
                            // copy date
                            await window.navigator?.clipboard.writeText(
                              e?.target?.value
                            );
                          }
                        }}
                        helperText={
                          errorMessagesFromRedux?.detailLogErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.detailLogErrors,
                                (l) => (l.field == 'batchDt' ? l.message : null)
                              )
                            : null
                        }
                        error={_.some(
                          errorMessagesFromRedux?.detailLogErrors,
                          (l) => l.field == 'batchDt'
                        )}
                      />
                    </MuiPickersUtilsProvider>
                    {/* <div className="frr-errorMessage">
                      {' '}
                      {errorMessagesFromRedux?.detailLogErrors?.length > 0
                        ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                            l.field == 'batchDt' ? l.message : null
                          )
                        : null}
                    </div> */}
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='batches-check-payee-detail'
                      id='batch-check-payee-detail'
                      label='Check Payee'
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={disabled || !isEnablebyRole}
                      select
                      inputProps={{
                        maxlength: 11,
                        id: 'batch-check-payee-detail',
                      }}
                      value={formValue.checkPayeeCd}
                      className={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'checkPayeeCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'checkPayeeCd' ? l.message : null
                            )
                          : null
                      }
                      onChange={(e) =>
                        onChangeFormAction('checkPayeeCd', e.target.value)
                      }
                      onBlur={(e) =>
                        onBlurFormAction('checkPayeeCd', e.target.value)
                      }
                    >
                      <MenuItem
                        key=''
                        value=''
                        className='frr-dropdown-blank-item'
                      />
                      {!_.isEmpty(batchForPayeeList)
                        ? batchForPayeeList.map((item) => (
                            <MenuItem key={item.id} value={item.id} className="frr-logcheck-dropdown-item">
                              {item.name}
                            </MenuItem>
                          ))
                        : null}
                    </TextField>
                    <div className='frr-errorMessage'>
                      {' '}
                      {errorMessagesFromRedux?.detailLogErrors?.length > 0
                        ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                            l.field == 'checkPayeeCd' ? l.message : null
                          )
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='batches-total-number-of-check-detail'
                      id='batch-total-number-of-check-detail'
                      label='Total Number of Checks'
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxlength: 5 }}
                      disabled={disabled || !isEnablebyRole}
                      className={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'totCheckCnt' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'totCheckCnt' ? l.message : null
                            )
                          : null
                      }
                      value={formValue.totCheckCnt}
                      onChange={(e) =>
                        onChangeFormAction('totCheckCnt', e.target.value)
                      }
                      onBlur={(e) =>
                        onBlurFormAction('totCheckCnt', e.target.value)
                      }
                    />
                    <div className='frr-errorMessage'>
                      {' '}
                      {errorMessagesFromRedux?.detailLogErrors?.length > 0
                        ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                            l.field == 'totCheckCnt' ? l.message : null
                          )
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='batches-total-amount-of-check-detail'
                      id='batch-total-amount-of-check-detail'
                      label='Total Amount of Checks'
                      autoComplete='off'
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={disabled || !isEnablebyRole}
                      className={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'totCheckAmt' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.detailLogErrors?.length > 0
                          ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                              l.field == 'totCheckAmt' ? l.message : null
                            )
                          : null
                      }

                      value={formValue.totCheckAmt
                        ?.toString()
                        ?.replace('$', '')}
                   
                      inputProps={{
                        maxLength: 16,
                        id: 'batch-total-amount-of-check-detail',
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                        startAdornment: (
                          <InputAdornment
                            position='start'
                            className='prefix-symbol'
                          >
                            $
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        if (!disabled) {
                          // if (e.target?.value?.includes('.')) {
                          //   const rx =
                          //     /^[A-Za-z0-9]{0,10}(\.[A-Za-z0-9]{0,2})?$/;
                          //   if (rx.test(e.target.value)) {
                          //     onChangeFormAction('totCheckAmt', e.target.value);
                          //   }
                          // } else {
                          //   const rx_without = /^[A-Za-z0-9]{0,10}?$/;
                          //   if (rx_without.test(e.target?.value)) {
                          onChangeFormAction('totCheckAmt', e.target.value);
                          //   }
                          // }
                        }
                      }}
                      onBlur={(e) => {
                        if (!disabled) {
                          onBlurFormAction('totCheckAmt', e.target?.value);
                        }
                      }}
                    />
                    <div className='frr-errorMessage'>
                      {' '}
                      {errorMessagesFromRedux?.detailLogErrors?.length > 0
                        ? _.map(errorMessagesFromRedux.detailLogErrors, (l) =>
                            l.field == 'totCheckAmt' ? l.message : null
                          )
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl '>
                    <div className='manufacturer-checkbox flex-box-100 frr-lb-checkbox'>
                      <FormControlLabel
                        className='mt-6 mr-0 frr-display-hidden-checkbox-label'
                        label='complete'
                        control={<Checkbox color='primary' />}
                        disabled
                        checked={
                          formValue?.cfFrozen
                            ? formValue?.cfFrozen != '0'
                            : false
                        }
                      />
                      <div className='label-font'>Complete</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset className='custom-fieldset mb-2 mt-2'>
            <legend className='same-font-family'>Check Log Totals</legend>
            <div className='row mb-2'>
              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='check-log-batches-total-number-of-check-detail'
                      id='check-log-batch-total-number-of-check-detail'
                      label='Total Number of Checks'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      inputProps={{ maxlength: 11 }}
                      value={checkVal.totChk ? checkVal.totChk : '0'}
                    />
                  </div>
                </div>
              </div>

              <div className='col-12 col-sm-6 col-md-4'>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-xl'>
                    <TextField
                      data-testid='check-log-batches-total-amount-of-check-detail'
                      id='check-log-batch-total-amount-of-check-detail'
                      label='Total Amount of Checks'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment className='prefix-symbol'>
                            $
                          </InputAdornment>
                        ),
                      }}
                      value={
                        checkVal.totAmt
                          ? formValue.actionType != 'Add'
                            ? checkVal.totAmt?.toString()?.replace('$', '')
                            : '0.00'
                          : '0.00'
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div className='log-batch-detail-btn-group welcometxt'>
            <div className='btn-wrapper'>
              <Button
                className='btn btn-success btn-save btn-primary'
                data-testid='log-batch-detail-history'
                onClick={getShowViewHistoryPlan}
                disabled={enableHistoryView}
              >
                <SVGComponent iconName='Icon-view-history' /> View History
              </Button>
              <Button
                disabled={saveDisabled || !isEnablebyRole}
                className='btn btn-success btn-save btn-primary'
                onClick={handleSave}
                data-testid='log-batch-detail-save'
              >
                <SVGComponent iconName='Icon-awesome-save' /> Save
              </Button>
              <Button
                disabled={cancelDisabled}
                className='btn btn-cancel btn btn-primary'
                onClick={handleCancel}
                data-testid='log-batch-detail-Cancel'
              >
                <SVGComponent iconName='Icon-cancel' /> Cancel
              </Button>
            </div>
          </div>
        </div>

        {historyView && (
          <ViewHistoryComponent
            setShowViewHistory={setHistoryView}
            tableName='BATCH_TOTALS'
            keyValue={keyValue}
            isSpinner
          />
        )}
      </div>
    </div>
  );
}

export default LogBatchTotalForm;
